import StartupFundraise from './container';

export default StartupFundraise;
